var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-theme-provider',{attrs:{"dark":_vm.dark}},[_c('div',[_c('base-info-card',{attrs:{"title":_vm.title,"pace":"6"}},[_vm._v(" Nous restons à votre disposition pour toutes vos questions! ")]),_c('base-business-contact')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }